<template>
  <section>
    <ul class="filters-list">
      <li>
        <router-link
          :to="{
            name: 'AllOrders',
            query: this.$route.query,
          }"
        >
          ALL
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  data() {
    return {
    };
  },
};
</script>
